module.exports = __webpack_public_path__ + "static/8-formation-deformation-s-xi-5e10b4d4bc31a5e4f6726ce1a782a8c3.jpg";